// extracted by mini-css-extract-plugin
export default {"BasicButtonContainer":"Button60_BasicButtonContainer__S82F4","BasicButton":"Button60_BasicButton__b+rXK","DisabledButton":"Button60_DisabledButton__BbLtI"};